import { render, staticRenderFns } from "./PopupCreateBeritaAcara.vue?vue&type=template&id=8a3228e0"
import script from "./PopupCreateBeritaAcara.vue?vue&type=script&lang=js"
export * from "./PopupCreateBeritaAcara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports